import React from 'react';
import { loadable } from 'components/Skeleton/LoadableSkeleton'; // This HAS to be called `loadable` to work with SSR
import Skeleton from 'components/Skeleton';

export const LoadableBoughtInStorePage = loadable(() => import('components/BoughtInStorePage'));

export const LoadableFavouritesPage = loadable(() => import('components/Favourites/Page'));

export const LoadableMoreOfWhatYouLovePage = loadable(
  () => import('components/MoreOfWhatYouLovePage'),
);

export const LoadableShopFromPrevious = loadable(() => import('components/ShopFromPrevious/Page'));

export const LoadableShopFromPreviousInterstitial = loadable(
  () => import('components/ShopFromPreviousInterstitial'),
);

export const LoadableListsPage = loadable(() => import('components/Lists/Page'));

export const LoadableShopByListPageForm = loadable(() => import('components/ShopByListPage/Form'));
export const LoadableShopByListUploadPage = loadable(
  () => import('components/ShopByListUploadPage'),
  { fallback: <Skeleton height="100vh" withSpinner /> },
);
export const LoadableShopByListPageSuggestions = loadable(
  () => import('components/ShopByListPage/Suggestions'),
);

export const LoadableMealDealsPage = loadable(
  () => import('components/MealDealPage/StrategicMealDealPage'),
);

export const LoadableMyOrdersPage = loadable(() => import('components/MyOrders'));

export const LoadableOfferDetailsPage = loadable(() => import('components/Offers/OfferDetails'));

export const LoadableQuickShopPage = loadable(() => import('components/QuickShopPage'));

export const LoadableServiceSelection = loadable(
  () => import('components/BookSlot/ServiceSelection'),
  {
    fallback: <Skeleton height="400px" />,
  },
);

export const LoadableTrolleyPage = loadable(() => import('components/Trolley'));
